import { IDailyResortLiftTickets, IResortPathInfo } from 'api/resort/types';
import { passTypes } from './constants';

export interface IDailyGridDataRow {
  passType: string,
  children: string | IResortPathInfo | null,
  teenager: string | IResortPathInfo | null,
  adult: string | IResortPathInfo | null,
  senior: string | IResortPathInfo | null,
}
export const restructureDailyGridData = (dailyLiftTickets: IDailyResortLiftTickets) => passTypes
  .reduce((acc: IDailyGridDataRow[], curr) => {
    const dataKey = curr[0].toUpperCase() + curr.substring(1);
    const children = dailyLiftTickets[`children${dataKey}Price` as keyof IDailyResortLiftTickets];
    const teenager = dailyLiftTickets[`teenager${dataKey}Price` as keyof IDailyResortLiftTickets];
    const adult = dailyLiftTickets[`adult${dataKey}Price` as keyof IDailyResortLiftTickets];
    const senior = dailyLiftTickets[`senior${dataKey}Price` as keyof IDailyResortLiftTickets];

    if (!children && !teenager && !adult && !senior) {
      return acc;
    }

    acc.push({
      passType: `resort.liftTickets.${curr}`,
      children,
      teenager,
      adult,
      senior,
    });

    return acc;
  }, []);
